// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch, Provide} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../icon/Icon'

// Mixins
import {EventBus} from './../../../mixins/event_bus/EventBus'

@Component({
    name: 'Dropdown',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class Dropdown extends mixins(EventBus) {

    public isLeft: boolean = true

    private isOpen: boolean = false
    private isUp: boolean = false

    @Provide('dropdownTheme')
    @Prop({default: 'default'})
    public theme!: string

    @Prop([String, Number])
    public header!: any

    @Prop()
    public label!: string

    @Prop()
    public iconName!: string

    @Prop()
    public iconFile!: string

    @Prop()
    public iconSize!: string

    @Prop({default: false})
    public up!: boolean

    @Prop({default: false})
    public disabled!: boolean

    public $refs!: {
        head: HTMLElement
        content: HTMLElement
    }

    @Watch('up')
    private watchUp(newUp, oldUp) {

        this.isUp = newUp
    }

    public created() {
        window.addEventListener('resize', this.handleResize)
        this.isUp = this.up
    }

    public mounted()  {

        const windowWidth = window.innerWidth || document.documentElement!.clientWidth

        this.isLeft = windowWidth - ((<HTMLElement>this.$refs.head).getBoundingClientRect().left + 230)> 0
    }

    public destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }

    public handleResize(e: Event) {

        const windowWidth = window.innerWidth || document.documentElement!.clientWidth

        this.isLeft = windowWidth - ((<HTMLElement>this.$refs.head).getBoundingClientRect().left + 230) > 0
    }

    private handleOpenOptions() {

        if (!this.up) {

            const fixedFooterElement = <HTMLElement>document.querySelector(`.${this.$appPrefix}-fixed-footer`)

            let offsetBottom = 0;
    
            if (fixedFooterElement) {
                offsetBottom += fixedFooterElement.offsetHeight
            }

            this.isUp = (this.$refs.head.getBoundingClientRect().bottom + this.$refs.content.offsetHeight + offsetBottom) > window.innerHeight

        } else {
            this.isUp = true
        }

        this.isOpen = true
    }

    private handleCloseOptions() {
        this.isOpen = false
        this.isUp = this.up
    }
}